<template>
	<app-page>
		<app-heading title="MarketMath">
			<template v-slot:left>
				<app-button v-if="$ravello.can('marketmath.post')"
					class="d-none d-sm-inline-flex"
					color="success"
					small
					outlined
					:to="{ name: 'market', params: { market: 'new' } }"
				>Add Market</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="markets"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					@update="fetchMarkets"
				>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('marketmath.get')"
							color="secondary"
							table
							@click="onManage(item._id)"
						>
							Manage
						</app-button>
						<app-button
							v-if="$ravello.can('marketmath.put')"
							color="secondary"
							:to="{ name: 'market', params: { market: item._id } }"
							icon="fa-pencil-alt"
							table
						>
							Edit
						</app-button>
						<app-button-confirm
							v-if="$ravello.can('marketmath.delete')"
							color="error"
							icon="fa-trash"
							table
							label-confirm="Remove"
							:description="`Are you sure you want to remove market <b>${item.name}</b>?`"
							title="Remove Market"
							@click="onDelete(item._id)"
						>
							Remove
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'market', params: { market: 'new' } }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
import countriesMap from '@/mixins/countriesMap'

export default {
	mixins: [countriesMap],
	data() {
		return {
			markets: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'State/Province',
				value: 'name',
				sortable: true,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: true,
			}, {
				text: 'Timezone',
				value: 'timezone',
				sortable: false,
			}, {
				text: 'Country',
				value: 'country',
				sortable: false,
				cb: item => this.getCountry(item.country),
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		onManage(id) {
			this.$store.dispatch('app/setNav', false)
			this.$router.push({ name: 'market-listings', params: { market: id } })
		},
		async fetchMarkets(pagination) {
			const request = this.$ravello.graphql('markets')
				.fromPagination(pagination)
				.fields(['_id', 'name', 'slug', 'timezone', 'country'])

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.markets = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
